export default __webpack_public_path__ + "static/optinly-about-us-banner-4e85c268980c934123c009c330c3a496.png";